import { render, staticRenderFns } from "./TituloWrapper.vue?vue&type=template&id=62cd6296"
import script from "./TituloWrapper.vue?vue&type=script&lang=js"
export * from "./TituloWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports